// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { Platform }           from 'ionic-angular';
import { NavController }      from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';

// External modules
import { Contact }            from '../../shared/models/contact';
import { Translation }        from '../../shared/models/translation';
import { ApplicationService } from '../../shared/providers/application-service';
import { TranslateService }   from '@ngx-translate/core';

// Helpers
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector    : 'page-contact',
  templateUrl : 'contact.html'
})
export class ContactPage
{
  user            : any           = null;
  data            : Contact[]     = [];
  countries       : string[]      = [];
  regions         : string[]      = [];
  contacts        : Contact[]     = [];
  translations    : Translation[] = [];
  waitingLabel    : string        = "Please wait...";
  isTablet        : boolean       = false;
  selectedCountry : string;
  selectedRegion  : string;

  constructor(public navCtrl:            NavController,
              public menuCtrl:           MenuController,
              public platform:           Platform,
              public loadingCtrl:        LoadingController,
              public toastCtrl:          ToastController,
              public applicationService: ApplicationService,
              public translateService:   TranslateService)
  {
    if(StorageHelper.getContacts() === null)
    {
      this.presentToast('You need to synchronize your data before accessing this feature');
      this.navCtrl.push(SynchronizePage);
      return;
    }

    platform.ready().then(() => {
      this.loadData()
      this.applicationService.getCountryCodeFromCoords()
      .subscribe(
        res => {
          this.loadData(res)
        },
        _ => this.presentToast(this.translateService.instant("NO_ACCESS_LOCATION"))
        )

      this.initTranslations();

      this.isTablet = this.platform.is('tablet') || this.platform.is('core');

      this.user = StorageHelper.getUser();
      this.getSelectedLang();
    });
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  getCountries(val: string) {
    // Reset items back to all of the items
    this.initializeCountries();

    if (val && val.trim() != '') {
      this.countries = this.countries.filter((item) => {
        return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

    if (this.isTablet && this.countries.length > 0)
      this.selectCountry(this.countries[0]);
  }

  getRegions(val: string) {
    // Reset items back to all of the items
    this.initializeRegions();

    if (val && val.trim() != '') {
      this.regions = this.regions.filter((item) => {
        return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }

    if (this.isTablet && this.regions.length > 0)
      this.selectRegion(this.regions[0]);
  }

  getContacts(val: string) {
    // Reset items back to all of the items
    this.initializeContacts();

    if (val && val.trim() != '') {
      this.contacts = this.contacts.filter((item) => {
        return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  selectCountry(country: string)
  {
    this.selectedCountry = country;
    if (this.selectedCountry)
      this.getRegions(null);
  }

  selectRegion(region: string)
  {
    this.selectedRegion = region;
    if (this.selectedRegion)
      this.getContacts(null);
  }

  initializeCountries()
  {
    this.countries = Array.from(new Set(this.data.map(ctc => ctc.CountryName)))
                      .sort((a,b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
  }

  initializeRegions()
  {
    this.regions = Array.from(new Set(this.data.filter(ctc => ctc.CountryName === this.selectedCountry).map(ctc => ctc.Region)))
                    .sort((a,b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
  }

  initializeContacts()
  {
    this.contacts = this.data.filter(ctc => ctc.CountryName === this.selectedCountry && ctc.Region === this.selectedRegion)
                      .sort((a,b) => a.Name.toLocaleLowerCase().localeCompare(b.Name.toLocaleLowerCase()));
  }

  loadData(country? : {code:string, name:string})
  {
    if (!country)
      return this.getContactsFromStorage();

    let loader  = this.presentLoading();
    loader.present();

    const contacts = StorageHelper.getContacts();
    this.data = (contacts).filter(ctc => ctc.Country === country.code).map(ctc => {ctc.CountryName = country.name; return ctc;});
    this.getCountries(null);
    loader.dismiss();
  }

  getContactsFromStorage()
  {
    const contacts = StorageHelper.getContacts();
    this.data = contacts;
    this.getCountries(null);
  }

  presentLoading()
  {
    let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    return loader;
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  initTranslations()
  {
    this.translateService.get('PLEASE_WAIT')
    .subscribe(
      value => {
        this.waitingLabel = value;
      }
    );
  }

  async getSelectedLang()
  {
    this.translations = await this.applicationService.getSelectedTranslations();
  }

  backAction() : void
  {
    if (this.isTablet)
    {
      this.navCtrl.pop({animate: false});
      return;
    }
    if (this.selectedRegion)
    {
      this.selectRegion(null);
      return;
    }
    if (this.selectedCountry)
    {
      this.selectCountry(null);
      return;
    }
    this.navCtrl.pop({animate: false});
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact.ts